import { createActions, createReducer } from 'reduxsauce';
import * as Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */
const tag = '[SAGA_OFFER_REDUX]'; // eslint-disable-line

const functionDefinitions = {

    /*---------- getAgents --------*/
    requestGetAgents: [],
    getAgentsSuccess: ['getAgentsResponse'],
    getAgentsFailure: ['getAgentsError'],

    /*---------- selectedDashboard --------*/
    requestSelectedDashboard: ['userId'],
    selectedDashboardSuccess: ['selectedDashboardResponse'],
    selectedDashboardFailure: ['selectedDashboardError'],

    /*---------- updateDashboardLayoutChanged --------*/
    requestUpdateDashboardLayoutChanged: ['userId', 'dashboardLayout', 'selectedDashboard'],
    updateDashboardLayoutChangedSuccess: ['updateDashboardLayoutChangedResponse'],
    updateDashboardLayoutChangedFailure: ['updateDashboardLayoutChangedError'],

    /*---------- getuserCalendar --------*/
    requestGetuserCalendar: ['userId', 'selectedMonth', 'selectedYear', 'dataType'],
    getuserCalendarSuccess: ['getuserCalendarResponse'],
    getuserCalendarFailure: ['getuserCalendarError'],

};

const { Types, Creators } = createActions(functionDefinitions);

export const SagaUserTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const SagaUserInitState = {};

export const INITIAL_STATE = Immutable(SagaUserInitState);

/* ------------- Reducers ------------- */

/*---------- getAgents --------*/
export const requestGetAgents = (state: Immutable) => {
    return state.merge(
        {
            getAgentsFetching: true,
            getAgentsError: null,
        });
};
export const getAgentsSuccess = (state, action) => {
    return state.merge(
        {
            getAgentsFetching: false,
            getAgentsResponse: action.getAgentsResponse,

        });
};
export const getAgentsFailure = (state, action) => {
    return state.merge(
        {
            getAgentsFetching: false,
            getAgentsError: action.getAgentsError,

        });
};

/*---------- selectedDashboard --------*/
export const requestSelectedDashboard = (state, action) => {
    return state.merge(
        {
            dashboardFetching: true,
            userId: action.userId,
            selectedDashboardError: null,
            selectedDashboardResponse: null
        });
};
export const selectedDashboardSuccess = (state, action) => {
    return state.merge(
        {
            dashboardFetching: false,
            selectedDashboardResponse: action.selectedDashboardResponse,
        });
};
export const selectedDashboardFailure = (state, action) => {
    return state.merge(
        {
            dashboardFetching: false,
            selectedDashboardError: action.selectedDashboardError,
        });
};

/*---------- updateDashboardLayoutChanged --------*/
export const requestUpdateDashboardLayoutChanged = (state, action) => {
    return state.merge(
        {
            updateDashboardLayoutChangedFetching: true,
            userId: action.userId,
            dashboardLayout: action.dashboardLayout,
            requestUpdateDashboardLayoutChanged,
            selectedDashboard: action.selectedDashboard,
            updateDashboardLayoutChangedResponse: null,
        });
};
export const updateDashboardLayoutChangedSuccess = (state, action) => {
    return state.merge(
        {
            updateDashboardLayoutChangedFetching: false,
            updateDashboardLayoutChangedResponse: action.updateDashboardLayoutChangedResponse,
        });
};
export const updateDashboardLayoutChangedFailure = (state, action) => {
    return state.merge(
        {
            updateDashboardLayoutChangedFetching: false,
            updateDashboardLayoutChangedError: action.updateDashboardLayoutChangedError,
        });
};

/*---------- getuserCalendar --------*/
export const requestGetuserCalendar = (state, action) => {
    return state.merge(
        {
            getuserCalendarFetching: true,
            userId: action.userId,
            selectedMonth: action.selectedMonth,
            selectedYear: action.selectedYear,
            dataType: action.dataType,
            getuserCalendarResponse: null,
            getuserCalendarError: null
        });
};
export const getuserCalendarSuccess = (state, action) => {
    return state.merge(
        {
            getuserCalendarFetching: false,
            getuserCalendarResponse: action.getuserCalendarResponse,
        });
};
export const getuserCalendarFailure = (state, action) => {
    return state.merge(
        {
            getuserCalendarFetching: false,
            getuserCalendarError: action.getuserCalendarError,
        });
};


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {

    /*---------- getAgents --------*/
    [Types.REQUEST_GET_AGENTS]: requestGetAgents,
    [Types.GET_AGENTS_SUCCESS]: getAgentsSuccess,
    [Types.GET_AGENTS_FAILURE]: getAgentsFailure,

    /*---------- selectedDashboard --------*/
    [Types.REQUEST_SELECTED_DASHBOARD]: requestSelectedDashboard,
    [Types.SELECTED_DASHBOARD_SUCCESS]: selectedDashboardSuccess,
    [Types.SELECTED_DASHBOARD_FAILURE]: selectedDashboardFailure,

    /*---------- updateDashboardLayoutChanged --------*/
    [Types.REQUEST_UPDATE_DASHBOARD_LAYOUT_CHANGED]: requestUpdateDashboardLayoutChanged,
    [Types.UPDATE_DASHBOARD_LAYOUT_CHANGED_SUCCESS]: updateDashboardLayoutChangedSuccess,
    [Types.UPDATE_DASHBOARD_LAYOUT_CHANGED_FAILURE]: updateDashboardLayoutChangedFailure,

    /*---------- getuserCalendar --------*/
    [Types.REQUEST_GETUSER_CALENDAR]: requestGetuserCalendar,
    [Types.GETUSER_CALENDAR_SUCCESS]: getuserCalendarSuccess,
    [Types.GETUSER_CALENDAR_FAILURE]: getuserCalendarFailure,

});



// WEBPACK FOOTER //
// ./src/redux/sagaUser/sagaUserRedux.ts